var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"avp-contact-link",attrs:{"href":_vm.phoneLink}},[_vm._v(_vm._s(_vm.$t('generic.support.phone')))])}
var staticRenderFns = []

export { render, staticRenderFns }